var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[(_vm.loaded)?_c('line-chart',{attrs:{"chart-data":_vm.datacollection}}):_vm._e(),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.fillData()}}},[_vm._v("Randomize")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e3b4c2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/simple-line-chart.vue
// module id = 1865
// module chunks = 0